// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {url2md5} from 'pub_config';
import styles_f from './svg.module.less';

export type t_sprite = 'icon'|'navig'|'pl'|'feature';
export type t_icon_size = 'xxs'|'xs'|'sm'|'md'|'lg'|'xl';
export interface i_svg_props {
    icon?: JSX.Element;
    w?: number;
    h?: number;
    cls?: string;
    type?: t_sprite;
    id?: string;
    size?: t_icon_size;
    percentage_size?: boolean;
    children?: React.ReactNode;
    on_click?: (e?:any)=>void;
}

export const get_url = (id:string, type?:string):string=>{
    // XXX volodymyr: temporary until mac_beta replaces old app
    const alias_id = id ? id.replace('mac_beta', 'mac') : id;
    const path = `svg/${type || 'icon'}/${alias_id}.svg`;
    const full_path = `/www/hola/pub/img/${path}`;
    const url = url2md5(full_path);
    return url;
};

const Svg_img = props=>{
    let {id, w, h, cls, type=null, size='md', children,
        percentage_size=false, on_click} = props;
    if (!w && !h)
    {
        switch (size)
        {
        case 'xxs': h = w = 12; break;
        case 'xs': h = w = 16; break;
        case 'sm': h = w = 20; break;
        case 'lg': h = w = 28; break;
        case 'xl': h = w = 32; break;
        default: h = w = 24; break;
        }
    }
    const proc_sz = (v, add='')=>{
        if (v && percentage_size)
            return `${v}%`;
        return v+(add||'');
    };
    const root_cls = cn(id, cls, styles_f.root_svg,
        !!on_click && styles_f.pointer);
    return <div className={root_cls} onClick={on_click}
      tabIndex={on_click ? 0 : undefined}>
      <img src={get_url(id, type)} width={proc_sz(w)} height={proc_sz(h)}
        alt="svg" className="lazyload"/>
      {children}
    </div>;
};

export const Svg = (props:i_svg_props)=>{
    let {icon, id, cls, on_click} = props;
    if (icon)
    {
        const root_cls = cn(id, cls, styles_f.root_svg,
            !!on_click && styles_f.pointer);
        return <div className={root_cls} onClick={on_click}
          tabIndex={on_click ? 0 : undefined}>{icon}</div>;
    }
    return <Svg_img {...props}/>;
};
